export const filterOptions = [
  {
    label: 'Todos',
    value: '',
  },
  {
    label: 'Consulta Processual',
    value: 'consulta-processual',
  },
  {
    label: 'Jurisprudência',
    value: 'jurisprudencia',
  },
  {
    label: 'Doutrina',
    value: 'doutrina',
  },
  {
    label: 'Artigos e Notícias',
    value: 'artigos-noticias',
  },
  {
    label: 'Diários Oficiais',
    value: 'diarios',
  },
  {
    label: 'Peças Processuais',
    value: 'pecas',
  },
  {
    label: 'Modelos',
    value: 'modelos-pecas',
  },
  {
    label: 'Legislação',
    value: 'legislacao',
  },
]
